import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { InstanceDto } from '@plugins/usersync-lib/instance';

import { DataService } from '../services';

export const instanceResolver: ResolveFn<Observable<InstanceDto>> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(DataService).fetchInstance();
};
